import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../store/authSlice';
import './Sidebar.css';

const Sidebar = () => {
  const { role } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div>
          <h2>PayrollApp</h2>
          <div className="role-badge">{role}</div>
        </div>
      </div>
      
      <nav className="sidebar-nav">
        <NavLink to="/dashboard" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>
          <span style={{marginRight:'10px'}}>㗊</span> Dashboard
        </NavLink>
        
        <NavLink to="/attendance" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>
          <span style={{marginRight:'10px'}}>🕒</span> Attendance
        </NavLink>
        
        <NavLink to="/users" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>
          <span style={{marginRight:'10px'}}>👥</span> Users
        </NavLink>

        <NavLink to="/roles" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>
          <span style={{marginRight:'10px'}}>🛡</span> Roles
        </NavLink>
      </nav>

      <div className="sidebar-footer">
        <button className="btn btn-danger" style={{width: '100%'}} onClick={() => dispatch(logout())}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
